import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import { useSelector } from '../store/utils';
import { DesBatteryStatus, Inverter } from '../shared';

export const FormattedBessStatus = () => {
  const batteryStatus = useSelector(({ variables }) => {
    const desBatteryContainerKey = Object.entries(
      variables.INVERTER_CONFIG ?? {}
    ).find(([, config]) => config.type === Inverter.DesBatteryContainer)?.[0];

    if (!desBatteryContainerKey) return undefined;

    return get(variables, [
      'INVERTER_STATS',
      desBatteryContainerKey,
      'batteryStatus',
    ]) as DesBatteryStatus | undefined;
  });

  const statusMapping: Record<DesBatteryStatus, ReactNode> = {
    [DesBatteryStatus.NONE]: (
      <FormattedMessage
        id="des_battery_container.status.none"
        defaultMessage="Neznámý stav"
      />
    ),
    [DesBatteryStatus.RUN]: (
      <FormattedMessage
        id="des_battery_container.status.run"
        defaultMessage="Běžný režim"
      />
    ),
    [DesBatteryStatus.OFF]: (
      <FormattedMessage
        id="des_battery_container.status.off"
        defaultMessage="Vypnuto"
      />
    ),
    [DesBatteryStatus.SLEEP]: (
      <FormattedMessage
        id="des_battery_container.status.sleep"
        defaultMessage="Režim spánku"
      />
    ),
    [DesBatteryStatus.ERROR]: (
      <FormattedMessage
        id="des_battery_container.status.error"
        defaultMessage="Chyba"
      />
    ),
  };

  return <>{statusMapping[batteryStatus ?? DesBatteryStatus.NONE]}</>;
};
